import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import PlayerExamResult from '@/views/exam/Results.vue';

export const teamPlayerExamResultRoute = {
  path: 'examResult',
  name: 'teamPlayerExamResult',
  component: PlayerExamResult,
  props: {
    playerResults: true
  },
  meta: {
    title: 'titles.team.examResult',
    breadcrumb: {
      title: 'breadcrumbs.teams.examResult'
    }
  },
  beforeEnter: (to: any, from: any, next: any) => {
    const teamId = tryParseInt(to.params.teamId);
    const profileId = tryParseInt(to.params.playerId);

    store.commit('exam/results/setFilters', { teamId, profileId, examId: undefined });

    store
      .dispatch('exam/list', {
        teamId,
        inheritedFromClub: true,
        clubId: undefined
      })
      .then(() => {
        if (!to.query.order) {
          next({ name: to.name, params: to.params, query: { order: 'date', desc: true } });
        } else {
          next();
        }
      })
      .catch(() => store.dispatch('notifyError', { title: 'messages.exam.listError' }));
  }
};
